import { IDs } from '../../helpers/IDs';
import { StructureTool } from '../../core/forms/helpers/structure_tool';
import { getKomplexRowClassname, getCombiFieldKey } from './getFormKey';
import formStyle from '../../core/forms/style/WForm.less';

const hiddenKomplexRows: any = {};
const testMode = false;

export function recordHiddenRows(domainKey: string, formKey: string, formConfig: any, jahr_von: number, jahr_bis: number, jahr: number, entity: string, formActive: boolean) {
    // Init hiRows
    if (!hiddenKomplexRows[domainKey]) {
        hiddenKomplexRows[domainKey] = {};
    }
    const hiRows = hiddenKomplexRows[domainKey];
    if (jahr === jahr_von) {
        const krClsPre = getKomplexRowClassname(formKey);
        Object.keys(hiRows).forEach((krCls: string) => {
            if (krCls.startsWith(krClsPre)) {
                delete hiRows[krCls];
            }
        });
    }
    // Set hiRows
    const structTool = new StructureTool(IDs.MOD_ETOOL);
    const struc = structTool.getStructure(IDs.MOD_ETOOL, entity);
    if (struc && Array.isArray(struc.ATTS)) {
        struc.ATTS.forEach((att: any) => {
            const fieldKey = att.KEY || getCombiFieldKey(att.COMBINATION_FIELDS);
            // const hasPropertyHiddenInput: boolean = formConfig[fieldKey] && formConfig[fieldKey].hasOwnProperty('hidden_input');
            const isHiddenInput: boolean = formConfig[fieldKey] && !!formConfig[fieldKey]['hidden_input'];
            const isCombiHiddenInput = Array.isArray(att.COMBINATION_FIELDS) && att.COMBINATION_FIELDS.every((fk: string) => formConfig[fk] && !!formConfig[fk]['hidden_input']);
            const krCls = getKomplexRowClassname(formKey, fieldKey);
            if (!hiRows[krCls]) {
                hiRows[krCls] = {};
                for (let j = jahr_von; j <= jahr_bis; j++) {
                    hiRows[krCls][j] = false;
                }
            }
            hiRows[krCls][jahr] = !formActive || isHiddenInput || isCombiHiddenInput;
            // console.log(krCls, jahr, hiRows[krCls][jahr], formActive, isHiddenInput);
        });
    }
}

export function hideKomplexRows(domainKey: string) {
    if (!hiddenKomplexRows[domainKey]) {
        hiddenKomplexRows[domainKey] = {};
    }
    const hiRows = hiddenKomplexRows[domainKey];
    // console.log(domainKey, hiRows);
    Object.keys(hiRows).forEach((krCls: string) => {
        const elements = document.getElementsByClassName(krCls);
        if (elements.length > 0) {
            const isHiddenRow = Object.keys(hiRows[krCls]).every((jahr: string) => hiRows[krCls][jahr] === true);
            const elementsArr = Array.from(elements);
            // formStyle.hideKomplexRows
            // formStyle.fieldBox
            if (testMode) {
                if (isHiddenRow) {
                    elementsArr.forEach((ele: any) => ele.classList.add(formStyle.hideKomplexRows_TestMode));
                } else {
                    elementsArr.forEach((ele: any) => ele.classList.remove(formStyle.hideKomplexRows_TestMode));
                }
            } else {
                if (isHiddenRow) {
                    elementsArr.forEach((ele: any) => ele.classList.add(formStyle.hideKomplexRows));
                } else {
                    elementsArr.forEach((ele: any) => ele.classList.remove(formStyle.hideKomplexRows));
                }
            }
        } else {
            // console.log(krCls);
        }
    });
}
